/** A short tick on devices that have a vibration motor; a no-op elsewhere. */
export function haptic(kind: "select" | "commit" = "select"): void {
  if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") return;
  navigator.vibrate(kind === "commit" ? [12, 30, 12] : 10);
}
